/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Umar",
  title: "Hi all, I'm Umar Farooq",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / Nestjs / React Native and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/umarfarooq478",
  linkedin: "https://www.linkedin.com/in/umarfarooq478/",
  gmail: "fumer9933@gmail.com",

  facebook: "https://www.facebook.com/umerfarooq478",
  medium: "https://medium.com/@muhammadumarfarooq478",

  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "BACKEND-INTENSIVE FULL STACK DEVELOPER EXPLORING SCALABLE SOLUTIONS",
  skills: [
    emoji(
      "⚡ Design and develop robust and scalable backends using NestJS and Node.js"
    ),
    emoji(
      "⚡ Efficient database design and management with MySQL, PostgreSQL, and NoSQL databases"
    ),
    emoji(
      "⚡ Build and maintain REST APIs and backend services for web and mobile applications"
    ),
    emoji(
      "⚡ Integrate and optimize cloud services such as AWS (Lambda, S3, Step Functions)"
    ),
    emoji(
      "⚡ Implement CI/CD pipelines and containerized solutions with Docker"
    )
  ],


  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "node",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
  
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-github"
    },
    {
      // react native
      skillName: "react-native",
      fontAwesomeClassname: "fab fa-react",
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "FAST - National University of Computer and Emerging Sciences",
      logo: require("./assets/images/nucesLogo.png"),
      subHeader: "Bachelors of Science in Computer Science",
      duration: "August 2019 - June 2023",
      desc: "Took courses about Software Engineering, Web Security, Operating Systems and more.",
      descBullets: [
        // worked in many societies
        "Worked in many societies including FPDC, FPS, and NUCS",
 
        "Worked in executive council of IEEE Students Chapter, and vice president of FPDC",

      ]
    },
  
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, // Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend Development", // Reflect backend expertise
      progressPercentage: "85%" // High proficiency in backend
    },
    {
      Stack: "Frontend Development", // Frontend as secondary focus
      progressPercentage: "70%" // Moderate proficiency in frontend
    },
    {
      Stack: "Database Management", // Strong database expertise
      progressPercentage: "90%" // High proficiency in database design and management
    },
    {
      Stack: "Cloud/DevOps", // Highlight cloud and DevOps skills
      progressPercentage: "75%" // Proficient in AWS and Docker
    },
    {
      Stack: "Programming",
      progressPercentage: "80%" // Overall strong programming skills
    }
  ],
  displayCodersrank: false // No change unless you want to display badges
};


// Work experience section

const workExperiences = {
  display: true, // Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Code-Huddle",
      companylogo: require("./assets/images/codeHuddleLogo.png"),
      date: "July 2013 – Present",
      desc: "Developed and maintained web applications using modern frameworks and technologies. Collaborated with cross-functional teams to deliver high-quality software solutions.",
      descBullets: [
        "Led the development of a scalable e-commerce platform",
        "Implemented CI/CD pipelines to streamline the deployment process",
        "Mentored junior developers and conducted code reviews"
      ]
    },
    {
      role: "Research & Web Development Intern",
      company: "CureMD",
      companylogo: require("./assets/images/curemdLogo.png"),
      date: "May 2017 – May 2018",
      desc: "Conducted research on web development trends and technologies. Assisted in the development of web applications and contributed to the improvement of existing systems.",
      descBullets: [
        "Researched and implemented new web technologies to enhance user experience",
        "Collaborated with the design team to create responsive and user-friendly interfaces",
       ]
    },
    {
      role: "Software Engineer Intern",
      company: "IKNEX Lab, FAST-NUCES",
      companylogo: require("./assets/images/iknexLabLogo.png"),
      date: "Jan 2015 – Sep 2015",
      desc: "Worked on various software development projects, gaining hands-on experience in coding, testing, and debugging. Contributed to the development of innovative solutions for research projects.",
      descBullets: [
        "Developed and tested software modules for research projects",
        "Collaborated with researchers to understand project requirements and deliver solutions",
        "Participated in team meetings and presented progress updates"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "Some big projects where I have created impact",
  projects: [
    {
      image: require("./assets/images/gymygLogo.png"),
      projectName: "Gymyg Fitness",
      projectDesc: "A comprehensive fitness platform offering personalized workout plans and nutrition guides.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://gymyg.fit/"
        },
        {
          name:"Install App (Android)",
          url:"https://play.google.com/store/apps/details?id=com.gymygclient&hl=en"
        }
        , {
          name:"Install App (iOS)",
          url:"https://apps.apple.com/us/app/gymyg-workout/id1660562430"
        }
        //  you can add extra buttons here.
      ]
        },
        {
      image: require("./assets/images/hdLogo.png"),
      projectName: "Honest Dog",
      projectDesc: "A comprehensive platform for lending, purchasing, and selling pets in Germany, ensuring a safe and reliable experience for pet lovers.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://honestdog.de/en"
        }
      ]
        },
        {
      image: require("./assets/images/easyFoodJournalLogo.webp"),
      projectName: "Easy Food Journal",
      projectDesc: "A user-friendly application for tracking daily activities and health goals, including water intake and calorie burn, with features for friendly competition.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://easy-food-journal.vercel.app"
        }
      ]
        },
        {
          image: require("./assets/images/grantYourRequestFoundationLogo.png"),
          projectName: "Grant Your Request Foundation",
          projectDesc: "An automated grant platform designed to provide equal opportunities for financial assistance quickly and efficiently.",
          footerLink: [
            {
            name: "Visit Website",
            url: "https://grantyourrequestfoundation.org"
            }
          ]
        },
        {
          image: require("./assets/images/mileMatcherLogo.png"),
          projectName: "Mile Matcher",
          projectDesc: "A GPS-based platform that allows athletes to compete with others worldwide, tracking their progress and performance in real-time.",
          footerLink: [
            {
              name: "Visit Website",
              url: "#"
            }
          ]
        },
        {
          image: require("./assets/images/autoIQLogo.png"),
          projectName: "AutoIQ",
          projectDesc: "A vehicle maintenance and diagnostics application that provides real-time insights and alerts for vehicle health, ensuring optimal performance and safety.",
          footerLink: [
            {
              name: "Visit Website",
              url: "#"
            }
          ]
        }
      ],
      display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    

    {
      title: "CureMD Young Inventor Program Winner",
      subtitle: "Winner of CureMD Young Inventor Program (2022)",
      image: require("./assets/images/yipWinner.png"),
      imageAlt: "CureMD Young Inventor Program Logo",
      footerLink: [
        {
          name: "Award Details",
          url: "https://www.curemd.com/yip-winners-2022.asp"
        }
      ]
    }
,
    {
      title: "Winner of STFS",
      subtitle: "Winner of STFS, by PSF in 2017",
      image: require("./assets/images/stfs.png"),
      imageAlt: "STFS Logo",
      footerLink: [
        {
          name: "Award Details",
          url: "https://psf.gov.pk/stfs.aspx"
        }
      ]
    }
    
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3000142478",
  email_address: "fumer9933@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
